module.exports = __webpack_public_path__ + "static/media/Before-Icon.49ed02af.svg";